import axios from "@/libs/http";

// 点击技术支持时记录
export const addTechView = ()=>{
    return axios.request({
        url: '/pageView/shop/tech',
        method: 'get'
    })
}
